import React from 'react';
import './App.css';

import { Router, Route, browserHistory } from 'react-router';

import Base from './Base';
import Scorecard from './Scorecard';
import BrushProviders from './BrushProviders';
import Patients from './Patients';
import Settings from './Settings';
import AuthCallback from "./AuthCallback";
import BrushlinkAuth from './BrushlinkCallback';

import ManufacturerBase from './ManufacturerBase';
import ManufacturerLogin from './ManufacturerLogin';
import ManufacturerContent from './ManufacturerContent';
import ManufacturerAnalytics from './ManufacturerAnalytics';
import ManufacturerSettings from './ManufacturerSettings';
import ManufacturerLogout from './ManufacturerLogout';
import ManufacturerBilling from './ManufacturerBilling';
import ManufacturerSubscribe from './ManufacturerSubscribe';

import AdminBase from './AdminBase';
import AdminLogin from './AdminLogin';
import AdminApprovals  from './AdminApprovals';
import AdminAnalytics from './AdminAnalytics';
import AdminLogging from './AdminLogging';
import AdminLogout from './AdminLogout';
import AdminBilling from './AdminBilling';

import 'iframe-resizer/js/iframeResizer.contentWindow';
import Oralb from "./Oralb";

class App extends React.Component {
  render() {
    return (
        <Router history={browserHistory}>
            <Route path="/" component={Base}>
                <Route path="/providers" component={BrushProviders} />
                <Route path="/analytics" component={Settings} />
                <Route path="/patients" component={Patients} />
                {/*<Route path="/settings" component={ScorecardSettings} />*/}
                <Route path="/brushlink-offline-callback" component={BrushlinkAuth} />
            </Route>

            <Route path="/mfg" component={ManufacturerBase} mfg="Brushlink">
                <Route path="/mfg/content" component={ManufacturerContent} />
                <Route path="/mfg/analytics" component={ManufacturerAnalytics} />
                <Route path="/mfg/settings" component={ManufacturerSettings} />
                <Route path="/mfg/logout" component={ManufacturerLogout} />
                <Route path="/mfg/billing" component={ManufacturerBilling} />
            </Route>

            <Route path="/admin" component={AdminBase}>
                <Route path="/admin/approvals" component={AdminApprovals} />
                <Route path="/admin/analytics" component={AdminAnalytics} />
                <Route path="/admin/log" component={AdminLogging} />
                <Route path="/admin/logout" component={AdminLogout} />
                <Route path="/admin/billing" component={AdminBilling} />
            </Route>

            <Route path="/mfg/login" component={ManufacturerLogin} />
            <Route path="/admin/login" component={AdminLogin} />
            <Route path="/mfg/subscribe" component={ManufacturerSubscribe} />

            <Route path="/scorecard(/:patid)" component={Scorecard} />

            <Route path="/oralb" component={Oralb} />

            <Route path="/auth/callback" component={AuthCallback} />
        </Router>
    );
  }
}

export default App;
